import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit"
import formReducer from "../features/formModal/FormSlice"
import policyAndTermsReducer from "../features/policyAndTermsModal/PolicyAndTermsSlice"

export const store = configureStore({
  reducer: {
    formReducer,
    policyAndTermsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
